import { render, staticRenderFns } from "./WqMessageRevPersonModal.vue?vue&type=template&id=3573cc46"
import script from "./WqMessageRevPersonModal.vue?vue&type=script&lang=js"
export * from "./WqMessageRevPersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports